(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-reels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.ig-reels[id]');
    sections.forEach(function (root) {
      var track = root.querySelector('[data-igr-track]');
      var prev = root.querySelector('[data-igr-prev]');
      var next = root.querySelector('[data-igr-next]');
      var dotsWrap = root.querySelector('[data-igr-dots]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var index = 0;

      function perView() {
        var w = window.innerWidth;
        if (w >= 1024) return 4;
        if (w >= 640) return 3;
        return 1;
      }
      function maxIndex() { return Math.max(0, slides.length - perView()); }
      function step() {
        if (slides.length < 2) return slides[0] ? slides[0].getBoundingClientRect().width : 0;
        return slides[1].getBoundingClientRect().left - slides[0].getBoundingClientRect().left;
      }
      function apply(animate) {
        if (window.matchMedia('(max-width: 767px)').matches) return;
        track.style.transition = animate ? 'transform 400ms ease-in-out' : 'none';
        track.style.transform = 'translateX(' + (-(index * step())) + 'px)';
        if (prev) prev.disabled = index <= 0;
        if (next) next.disabled = index >= maxIndex();
        updateDots();
      }
      function goTo(i) { index = Math.max(0, Math.min(i, maxIndex())); apply(true); }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var pages = maxIndex() + 1;
        for (var i = 0; i < pages; i++) {
          var d = document.createElement('button');
          d.setAttribute('aria-label', 'Ir al grupo ' + (i + 1));
          if (i === 0) d.classList.add('is-active');
          (function (idx) { d.addEventListener('click', function () { goTo(idx); }); })(i);
          dotsWrap.appendChild(d);
        }
      }
      function updateDots() {
        if (!dotsWrap) return;
        var kids = dotsWrap.children;
        for (var i = 0; i < kids.length; i++) kids[i].classList.toggle('is-active', i === index);
      }

      if (prev) prev.addEventListener('click', function () { goTo(index - 1); });
      if (next) next.addEventListener('click', function () { goTo(index + 1); });

      /* Swipe táctil (desktop usa scroll nativo en móvil) */
      var x0 = null;
      track.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = x0 - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40 && !window.matchMedia('(max-width: 767px)').matches) { goTo(index + (dx > 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });

      /* Arrastre con ratón (desktop) */
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        var dragging = false, didDrag = false, dragX0 = 0, base = 0;
        track.addEventListener('dragstart', function (e) { e.preventDefault(); });
        track.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          dragging = true; didDrag = false; dragX0 = e.clientX; base = -(index * step());
          track.classList.add('is-dragging'); track.style.transition = 'none'; document.body.style.userSelect = 'none';
        });
        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - dragX0; if (Math.abs(dx) > 6) didDrag = true;
          track.style.transform = 'translateX(' + (base + dx) + 'px)';
        });
        document.addEventListener('mouseup', function (e) {
          if (!dragging) return;
          dragging = false; track.classList.remove('is-dragging'); document.body.style.userSelect = '';
          var dx = e.clientX - dragX0, s = step();
          if (didDrag && s) goTo(index + Math.round(-dx / s)); else apply(false);
        });
        track.addEventListener('click', function (e) { if (didDrag) { e.preventDefault(); e.stopPropagation(); didDrag = false; } }, true);
      }

      /* Reproducir SOLO los vídeos visibles (rendimiento) */
      var vids = root.querySelectorAll('[data-igr-video]');
      if (vids.length && 'IntersectionObserver' in window) {
        var vio = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            var v = en.target;
            if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
            else { v.pause(); }
          });
        }, { threshold: 0.5 });
        vids.forEach(function (v) { vio.observe(v); });
      }

      buildDots();
      apply(false);
      window.addEventListener('resize', function () { buildDots(); index = Math.min(index, maxIndex()); apply(false); });
      window.addEventListener('load', function () { apply(false); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-notification"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sales-notif]');
    var dataEl = document.querySelector('[data-sales-notif-data]');
    if (!root || !dataEl) return;
    var entries;
    try { entries = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!entries || !entries.length) return;
    try { if (sessionStorage.getItem('sn-dismissed')) return; } catch (e) {}

    var firstDelay = (parseFloat(root.getAttribute('data-first-delay')) || 5) * 1000;
    var visibleMs  = (parseFloat(root.getAttribute('data-visible-time')) || 6) * 1000;
    var gapMs      = (parseFloat(root.getAttribute('data-gap-time')) || 10) * 1000;
    var loop       = root.getAttribute('data-loop') !== 'false';
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var exitMs = reduce ? 0 : 400;

    var link  = root.querySelector('[data-sn-link]');
    var img   = root.querySelector('[data-sn-img]');
    var nameE = root.querySelector('[data-sn-name]');
    var titleE = root.querySelector('[data-sn-title]');
    var timeE = root.querySelector('[data-sn-time]');
    var closeBtn = root.querySelector('[data-sn-close]');

    var i = 0, timer = null, closed = false;

    function fill(e) {
      if (img) { img.src = e.img || ''; img.alt = e.alt || ''; }
      if (nameE) nameE.textContent = e.name ? (e.location ? e.name + ' de ' + e.location : e.name) : (e.location || '');
      if (titleE) titleE.textContent = e.title || '';
      if (timeE) timeE.textContent = e.time || '';
      if (link) link.setAttribute('href', e.url || '#');
    }
    function show() {
      if (closed) return;
      fill(entries[i]);
      root.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-visible'); }); });
      timer = setTimeout(hide, visibleMs);
    }
    function hide() {
      root.classList.remove('is-visible');
      timer = setTimeout(function () {
        root.hidden = true;
        i++;
        if (i >= entries.length) { if (!loop) return; i = 0; }
        timer = setTimeout(show, gapMs);
      }, exitMs);
    }
    function stop() { if (timer) { clearTimeout(timer); timer = null; } }

    if (closeBtn) closeBtn.addEventListener('click', function () {
      closed = true; stop();
      root.classList.remove('is-visible');
      setTimeout(function () { root.hidden = true; }, exitMs);
      try { sessionStorage.setItem('sn-dismissed', '1'); } catch (e) {}
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); }
      else if (!closed && !timer && root.hidden) { timer = setTimeout(show, gapMs); }
    });

    timer = setTimeout(show, firstDelay);
  })();

  } catch(e) { console.error(e); }
})();
})();
